export const WHERE_FROM = "Where from?";
export const WHERE_TO = "Where to?";
export const FLIGHTS = "Flights";
